// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#user {\n  height: 100%;\n}\n#user .uni-icon-setting {\n  margin-right: 4px;\n}\n#user .uni-icon-setting:before {\n  color: #fff;\n}", ""]);
// Exports
module.exports = exports;
